export const EMAIL_SERVICE_ID = "service_hdkvnk8"
export const EMAIL_TEMPLATE_ID = "template_6c2im5t"
export const EMAIL_API_KEY = "IUTrrqqFv4fVwj8xQ"
